<template>
  <v-app>
    <AppNavigationDrawer />
    <AppBar />

    <v-content>
      <transition name="slide-y-transition" mode="out-in">
        <router-view :key="$route.fullPath" />
      </transition>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'AppContent',
}
</script>
